const SupplierServicesType = (type) => {
  if (type === "E") {
    return "Economy";
  } else if (type === "X") {
    return "Express";
  } else if (type === "C") {
    return "Kargo";
  } else if (type === "P") {
    return "Postal";
  }
};

export default SupplierServicesType;
